import React from 'react';
import { TextField } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { Controller } from 'react-hook-form';

function MandatoryTagGroup(props) {
    const { control, tagGroup, errors } = props;
    return (
        <Controller
            control={control}
            name={tagGroup.field_key}
            render={({ field: { onChange, value } }) => (
            <Autocomplete
                fullWidth={true}
                multiple
                options={tagGroup.tags}
                getOptionLabel={(option) => option.name}
                getOptionSelected={ (option, value) => option.id == value.id }
                onChange={(event, value) => { onChange(value) }}
                value={value ?? []}
                renderInput={(params) => 
                    <TextField
                        {...params}
                        label={tagGroup.name}
                        variant="outlined"
                        error={errors[tagGroup.field_key] ? true : false}
                        helperText={errors?.[tagGroup.field_key]?.message ?? undefined}
                    />
                }
            />)}
        />
    );
}

export default MandatoryTagGroup;
